import React, { useContext, useState } from 'react'
import axios from 'axios'

import { Dialog } from 'primereact/dialog'

import { Field, FieldGroup, Form } from 'Components/form'
import { FileUpload } from 'Components/input'
import { Button, ModalActionsFooter } from 'Components/readonly'
import { GrowlContext } from 'Context'
import { FormattedHTMLMessage, injectIntl } from 'react-intl'

const MatchFileUploadModal = ({
                            isOpen,
                            setIsOpen,
                            intl
                          }) => {
  const { displaySuccess, displayError } = useContext(GrowlContext)
  const [isLoading, setIsLoading] = useState(false)
  const [isMatchFileUploadSuccessful, setIsMatchFileUploadSuccessful] = useState(false)
  const [matchUuid, setMatchUuid] = useState(null)
  const [hasSelectedFile, setHasSelectedFile] = useState(false)

  const onSubmit = async (sendData, formData) => {

    // Disable button and show spinner
    setIsLoading(true)

    // Send the data to server
    try {
      const response = await axios.post('/rapi/chemicals/match', sendData)
      if (response.data.success) {
        displaySuccess(response.data.message)
        // Store uuid of match file
        setMatchUuid(response.data.uuid)
        // Change component visibility
        setIsMatchFileUploadSuccessful(true)
      } else {
        displayError(response.data.message || 'Ett okänt fel uppstod')
      }
    } catch (error) {
      displayError(error?.response?.data?.message || error.message || 'Ett okänt fel uppstod')
    } finally {
      setIsLoading(false)
    }
  }

  const downloadMatchResult = async (sendData, formData) => {
    window.open('/rapi/chemicals/match/' + matchUuid)
    setIsOpen(false)
  }

  const downloadTemplate = () => {
    const fields = [
      intl.formatMessage({ id: 'chemicals.product' }),
      intl.formatMessage({ id: 'common.supplier' }),
    ]
    const header = fields.join(';')
    const csvContent = '\uFEFF' + header + '\n'

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = intl.formatMessage({ id: 'chemicals.matchfileupload.template_filename' })
    link.style.display = 'none'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    URL.revokeObjectURL(url)
  }

  const validateFile = (value) => {
    if (value.some((file) => !file.deleted && file.file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
      return { id: 'validation.upload_requires_excel' }
    }
  }

  React.useEffect(() => {
    if (!isOpen) {
      setIsMatchFileUploadSuccessful(false)
      setIsLoading(false)
      setHasSelectedFile(false)
    }
  }, [isOpen])
  
  return (
    (isOpen) && (
      <>
        <Dialog
          header={intl.formatMessage({ id: 'chemicals.matchfileupload.header' })}
          modal={true}
          visible={isOpen}
          appendTo={document.body}
          onHide={() => setIsOpen(false)}>
          <Form onSubmit={onSubmit} useFormData={true}>
            <FieldGroup
              mode="compact"
            >
              {!isMatchFileUploadSuccessful && (
                <Field
                  id="matchfile"
                  text={intl.formatMessage({ id: 'chemicals.matchfileupload.file' })}
                  Component={FileUpload}
                  multiple={false}
                  required={true}
                  validation={validateFile}
                  accept={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
                  onChange={(e) => {
                    const files = e.target.value || []
                    setHasSelectedFile(files.some((f) => !f.deleted))
                  }}
                />
              )}
              {isMatchFileUploadSuccessful && (
                <p style={{ marginTop: '0.5rem'}}>
                  <FormattedHTMLMessage id="chemicals.matchfileupload.message" />
                </p>
              )}
            </FieldGroup>
            <ModalActionsFooter style={{ width: '100%', alignItems: 'center' }}>
              <div style={{ marginRight: 'auto', marginLeft: '15px' }}>
                {!hasSelectedFile && (
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault()
                      downloadTemplate()
                    }}
                    style={{
                      color: 'var(--primary-color)',
                      textDecoration: 'none',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.35rem',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <i className="pi pi-download" />
                    {intl.formatMessage({ id: 'chemicals.matchfileupload.download_template' })}
                  </a>
                )}
              </div>
              {!isMatchFileUploadSuccessful ? (
                <>
                  <Button label={intl.formatMessage({ id: 'common.cancel' })} onClick={() => setIsOpen(false)} />
                  <Button
                    primary
                    submit
                    label={intl.formatMessage({ id: 'chemicals.matchfileupload.upload' })}
                    isLoading={isLoading}
                  />
                </>
              ) : (
                <>
                <Button label={intl.formatMessage({ id: 'common.cancel' })} onClick={() => setIsOpen(false)} />
                <Button
                  primary
                  icon="pi pi-save"
                  label={intl.formatMessage({ id: 'chemicals.matchfileupload.download_button' })}
                  onClick={downloadMatchResult}
                />
                </>
              )}
            </ModalActionsFooter>
          </Form>
        </Dialog>
      </>
    )
  )
}

export default injectIntl(MatchFileUploadModal)
